<template>
	<div class="mygoods">
		<el-dialog
		:title="$t('other.a653')"
		:visible.sync="dialogVisibleThree"
		width="30%"
		>
		<div style="margin-bottom:20px">{{$t('other.a653')}}：
			<el-select v-model="chosedStore"  :placeholder="$t('mygoods').qingdang.choose" >
				<el-option v-for="store in storeList" :key="store.value" :label="store.label" :value="store">
				</el-option>
			</el-select>
		</div>
		<div>{{$t('other.a1925')}}：
			<el-select v-model="isComponent" :placeholder="$t('other.a50')">
				<el-option
					v-for="item in options"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
			</el-select>

		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisibleThree = false">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="allInput()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>

		<!-- 商品清单 -->
		<el-dialog :title="$t('mygoods').qingdang.title" :visible.sync="caigouTable"  width="70%">
			
				<el-table :data="isChooseList" height="450" border>
					<el-table-column property="name" :label="$t('mygoods').qingdang.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" label="" trigger="hover">
								<img  :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img   slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="name" :label="$t('mygoods').qingdang.name" width="280" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.name" clearable></el-input>
						</template>
					</el-table-column>
					<el-table-column property="variation.name" label="sku" width="200" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.variation.name" ></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="$t('mygoods').qingdang.cost" width="100">
						<template scope="scope">
							<el-input size="mini"  type="number"  v-model="scope.row.cost" clearable></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a1926')" >
						<template scope="scope">
							<el-select v-model="scope.row.component" :placeholder="$t('other.a50')">
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value">
									</el-option>
							</el-select>
								
						</template>
					</el-table-column>
					<el-table-column :label="$t('mygoods').qingdang.operate" width="100px">
						<template scope="scope">
							<el-button type="text" size="mini" @click="deleteChoose(scope.row)" style="width: 60px;">{{$t('mygoods').qingdang.dele}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="choos-store">
					<div class="select-store">
						<span>{{$t('mygoods').qingdang.store}}：</span>
						<el-select v-model="chosedStore" size="small" :placeholder="$t('mygoods').qingdang.choose" style="margin-right: 300px;">
							<el-option v-for="store in storeList" :key="store.value" :label="store.label" :value="store">
							</el-option>
						</el-select>
					</div>
					<div >
						<el-button size="mini" @click="cleanForm">{{$t('mygoods').qingdang.qingkong}}</el-button>
						<el-button size="mini" @click="createOrder" type="primary">{{$t('mygoods').qingdang.submit}}</el-button>
					</div>
				</div>
			
		</el-dialog>
			<!-- 商品导入成功或失败的提示 -->
		<el-dialog :title="$t('mygoods').details.title" :visible.sync="storetable" center width="80%">
			<div class="quit-wapper">
				<span class="quit-wrapper-item">{{$t('mygoods').details.success}}</span>
				<span class="quit-wrapper-item">{{$t('mygoods').details.fail}}</span>
			</div>
			<div class="quit-box" >
				<el-table style="margin-left: 10px;" :data="succesList"  height="460px" border>
					<el-table-column property="name" :label="$t('mygoods').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<!-- <el-input size="mini" v-model="scope.row.image" clearable></el-input> -->
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="itemName" :label="$t('mygoods').details.name" width="190" :show-overflow-tooltip="true">
						<!-- <template scope="scope">
							<el-input size="mini" v-model="scope.row.itemName" clearable></el-input>
						</template> -->
					</el-table-column>
					<el-table-column property="skuName" :label="$t('mygoods').details.SKU" width="150" :show-overflow-tooltip="true">
						<!-- <template scope="scope">
							<el-input size="mini" v-model="scope.row.skuName" clearable></el-input>
						</template> -->
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('mygoods').details.cusCode" width="136" :show-overflow-tooltip="true">
					<!-- 	<template scope="scope">
							<el-input size="mini" v-model="scope.row.cusCode" clearable></el-input>
						</template> -->
					</el-table-column>
					
				</el-table>
				<el-table style="margin-left: 10px;" :data="errorList" height="460px" border>
					<el-table-column property="name" :label="$t('mygoods').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<!-- <el-input size="mini" v-model="scope.row.image" clearable></el-input> -->
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="itemName" :label="$t('mygoods').details.name" width="190" :show-overflow-tooltip="true">
						<!-- <template scope="scope">
							<el-input size="mini" v-model="scope.row.itemName" clearable></el-input>
						</template> -->
					</el-table-column>
					<el-table-column property="skuName" :label="$t('mygoods').details.SKU" width="150" :show-overflow-tooltip="true">
					<!-- 	<template scope="scope">
							<el-input size="mini" v-model="scope.row.skuName" clearable></el-input>
						</template> -->
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('mygoods').details.cusCode" width="136" :show-overflow-tooltip="true">
						<!-- <template scope="scope">
							<el-input size="mini" v-model="scope.row.cusCode" clearable></el-input>
						</template> -->
					</el-table-column>
					
					
				</el-table>

			</div>
			
			<div class="ttp-uu">
				<el-button @click="closeWindow" type="primary">{{$t('mygoods').details.ok}}</el-button>
			</div>
			
		</el-dialog>
		<div class="header-top">
			<div class="query-list">
				<!-- 菜单栏左 -->
				<div class="query-list-tcp">
					<div >
						<el-select   @change="getShopItemsCopy()" v-model="selectShop" :placeholder="$t('other.a50')">
						    <el-option
						      v-for="item in shopList"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select>
					</div>
					<div style="display:flex;margin-left:10px">
						<el-input clearable  @change="goTosearch()" style="width:350px" :placeholder="$t('other.a1927')" v-model="itemNameQuery"></el-input>
						 <el-button style="margin-left:6px"  type="primary">{{$t('binditems').search}}</el-button>
					</div>
				</div>
				<!-- 菜单栏右 -->
				<div class="query-list-tcp">
					<div class="create" >
						<el-button type="primary" @click="inputProduct()" size="small" >{{$t('other.a1928')}}</el-button>
					</div>
					<div class="create" >
						<el-button type="primary" @click="tobuShopee" size="small" >{{$t('other.a1929')}}</el-button>
					</div>
					<div class="create" v-show="!isBindItemModel">
						<el-button type="primary" @click="tocaiguo" size="small" >{{$t('mygoods').Generate_warehouse_items}}</el-button>
					
						<span class="cirlle">{{count}}</span>
					</div>
				</div>
				
			</div>
		</div>
		<div style="margin-top: 180px;margin-bottom: 100px">
				    <div class="mygoods-list-lazada">
					<div style="text-align: center;margin-top: 150px;" v-if="!lazadaitems.length " >--{{$t('userStoreItems').nodata}}--</div>
				   	<div v-for="item in lazadaitems" :key="item.itemId">
				   		<div class="list-item">
				   			<el-row>
				   				<el-col :span="24">
				   					<div class="item-view-lazada ">
				   						<div class="goods-pic"><img :src="changeImgURL(item)"></div>
				   						<div class="goods-desc">
				   							<div class="goods-title">{{item.name}}</div>
				   							<div class="goods-title-desc">
				   								<span class="goods-item">{{$t('mygoods').itemID}}：{{item.itemId}}</span>
				   								
												<span class="goods-item">{{$t('other.a838')}}：{{item.shopName}}</span>
				   							</div>
				   						</div>
				   					</div>
				   				</el-col>
				   			</el-row>
				   			<el-row v-show="item.hasVariation">
				   				<el-col :span="24">
				   					<div class="list-variation">
				   						<div v-for="(variation,index) in item.variations" :key="index" class="variation-list">
				   							<div class="goods-title-desc">
				   								<el-row>
				   									<el-col :span="1" class="goods-item"></el-col>
													<el-col :span="5" class="goods-item">&nbsp;&nbsp;&nbsp;sku：{{variation.variationSku}}</el-col>
				   									<el-col :span="9" class="goods-item">&nbsp;&nbsp;&nbsp;{{$t('other.a586')}}：{{variation.name}}</el-col>
				   							<!-- 		<el-col :span="6" class="goods-item">{{$t('mygoods').price}}：{{variation.price}}({{item.currency}})</el-col> -->
				   									<el-col :span="3" class="goods-item">{{$t('mygoods').stock}}：{{variation.stock}}</el-col>
				   									<el-col :span="6" v-if="variation.cusCode>0" class="goods-item">{{$t('mygoods').cusCode}}：{{variation.cusCode}}</el-col>
				   									<el-col :span="6" class="goods-btn">
				   										<!-- <el-button style="min-width:120px"  type="primary" size="mini"  v-show="!variation.cusCode " v-if="!variation.checked"  @click="targetVariation(item,variation)"  >{{$t('mygoods').Generate_warehouse_items}}</el-button> -->
														<el-dropdown  v-show="!isBindItemModel&&variation.cusCode==0&&!variation.checked">
															<span class="el-dropdown-link">
															<el-button style="width:130px; margin: 5px 0 0 0;" type="primary" size="mini"  v-show="!isBindItemModel&&variation.cusCode==0">{{$t('other.a1930')}}</el-button>
															</span>
															<el-dropdown-menu slot="dropdown">
															<el-dropdown-item  @click.native="targetVariation(item,variation,true,2,indexOne,index)">{{$t('other.a1931')}}</el-dropdown-item>
															<el-dropdown-item  @click.native="targetVariation(item,variation,false,2,indexOne,index)">{{$t('other.a1932')}}</el-dropdown-item>
															</el-dropdown-menu>
														</el-dropdown> 
				   										<el-button style="min-width:130px"  type="danger" size="mini" @click="targetVariation(item,variation)" v-if="variation.checked"  v-show="!variation.cusCode">{{$t('mygoods').isTarget}}</el-button>
				   										<el-button style="min-width:130px"  type="success" size="mini" v-show="variation.cusCode>0&&!isBindItemModel">{{$t('mygoods').generated}}</el-button>
				   									</el-col>
				   								</el-row>
				   							</div>
				   						</div>
				   					</div>
				   				</el-col>
				   			</el-row>
				   		</div>
				   	</div>
				   	<!-- 分页器 -->
				   	<div v-if="lazadaitems.length "  class="Pager">
				   	    <el-pagination
				   	      @size-change="handleSizeChange"
				   		@current-change="handleCurrentChange"
				   		:current-page="currentPage1"
				   		:page-sizes="[15, 20, 30, 50]"
				   		:page-size="getDataPrams.offset"
				   		layout="total, sizes, prev, pager, next, jumper"
				   		:total="lazadaCount">
				   	    </el-pagination>
				   	  </div>
				   </div>
			  
	
		</div>
		
		
		
	</div>
</template>

<script>
	import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
	import utils from  '../../utils/utils.js'
	import api from '../../api/api.js'
	import mygoods from '../../api/moudles/mygoods'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')) ,
				userShopslazada:JSON.parse(localStorage.getItem('lazadashopId')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				lazadashopId: JSON.parse(localStorage.getItem('lazadashopId')),
				dialogVisibleThree:false,
				shopList: [{
					label: this.$t('mygoods').allShop,
					value: '',
					children:null,
				},],
				storeList: [],
				status: {
					NORMAL: this.$t('other.a1082'),
					UNLIST: this.$t('other.a1083'),
					BANNED: this.$t('other.a1911'),
					DELETED: this.$t('other.a1912')
				},
				shipId: {
					value:{
						label:''
					}
				},
				chosedStore: '',
				itemNameQuery: null,
				statusValue: '',
				isChooseList: [],
				isComponent:true,
				syncOrders:false,
				bindItemList: [],
				variantList:[],
				caigouTable: false,
				productOptions:[{
					 value: 'NORMAL',
					 label: this.$t('other.a1636')
				},{
					 value: 'UNLIST',
					 label: this.$t('other.a1083')
				},{
					 value: 'BANNER',
					 label: this.$t('other.a1637')
				},],
				productStatua:'NORMAL',
				bindTable: false,
				count: 0,
				catergoryType:0,
				active:-1,
				dialogVisible: false,
				showStore:false,
				remindDialog: false,
				itemCount: 0,
				arr: [],
				chooseParams:null,
				isBindItemModel: false,
				sellerMessage: "",
				visiableMessage: '',
				stockRemindList: [],
				remindCount: 0,
				selectShop: null,
				offset:15,
				currentPage:0,
				type:0,
				currentPage1:0,
				goodsName:null,
				cost_prict:'',
				sku_name:'',
				storetable:false,
				input10:'',
				bindSuccess:[],
				bindError:[],
				bindreport:false,
				options:[{
					label:this.$t('other.a1933'),
					value:true,
				},{
					label:this.$t('other.a1934'),
					value:false,
				}],
				addItmes:this.$t('other.a1913'),
				activeTheOne:true,
				activeName: 'first',
				isShopee:true,
				showSales:false,
				salesItem:null,
				choseCategroyId:0,
				whichMethods:null,
				selectedOptions2:[],
				text:'',
				options5:[],
				value10:[],
				getDataPrams:{
					categoryIds:null,
					itemName:null,
					offset:15,
					page:0,
					shopIds:null,
					status:'NORMAL',
					userId:JSON.parse(localStorage.getItem('userInfo')).userId
				},
				
			}
		},
		components: {
			QrcodeDialog 
		},
		
		computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
				userPos: state => state.shopaccess.userInfo.userPos,
				goodsTotal:state => state.mygoods.goodsTotal,
				successtotal:state => state.mygoods.successtotal,
				errorList:state => state.mygoods.errorList,
				succesList:state => state.mygoods.succesList,
				curCodeList:state => state.mygoods.curCodeList,
				lazadaitems:state => state.mygoods.lazadaitems,
				lazadaCount:state => state.mygoods.lazadaCount,
				cateGoryListCopy:state => state.mygoods.cateGoryListCopy,
				already:state => state.mygoods.already,
				
			}),
			
			targetList(){
				let arr=this.mygoodslist.filter(p => {
					if(p.checked02){
						return p
					}
				})
				return arr
				
			},
			remindList() {
				return this.stockRemindList;
			},
			newmygoodslist(){
	
				let arr=this.mygoodslist
				
				return arr
			},
		
				
		},
		watch:{
			already(){
				if(this.already){
					this.shopList=[{
					label: this.$t('mygoods').allShop,
					value: '',
					children:null,
				},]
					 this.ttp()
				
				}
			},
			dialogVisibleThree(){
				if(!this.dialogVisibleThree){
					this.chosedStore=''
				}
			},
			itemNameQuery(){
				if(!this.itemNameQuery){
					this.getDataPrams.itemName=null
					this.getShopItems()
				}
				
			},
			successtotal(){
				this.showMessage(this.$t('other.a964')+this.successtotal+this.$t('other.a1914')+this.shipId.shopId.shopName + this.$t('other.a1861'))
			},
			selectedOptions2() {
			      if (this.$refs.refHandle) {
			        this.$refs.refHandle.dropDownVisible = false; //监听值发生变化就关闭它
			      }
			    }
		},
		created(){
			this.ttp()
		},
		methods: {
			...mapActions('mygoods', [
			'getShopAllItems',
			'addGoodsInStore',
			'getBindInfo',
			'tongBuShopee',
			'getLazadaWarehouseitems',
			'tongBuLazada',
			'getGoodsOrder',
			'getItemSales',
			'getInventoryTurnover',
			'getCategoryByshop',
			'batchCreateStoreItem'
			]),
			
			...mapMutations('mygoods', [
			'GET_CURCODE_LIST_NULL',
			'SET_SUCCESS_ERROR_NULL',
			'KEEP_CHOOSED_ITEM',
			'SET_ITEM_TRUE'
				
			]),
			
			comfirm(){
				console.log(this.value10)
				let arr=this.value10.map(p => {
					return {
						shopId:p
					}
				})
				arr.forEach(p => {
					this.tongBuShopee(p)
				})
				
				this.$message.success(this.$t('other.a1935'))
				this.syncOrders=false
			
			},
			
			showShopName(id){
				let ccp=null
				if(this.userPos === 'SELLER'){
					ccp=utils.showshopNameByshopId()
					return ccp[id]
				}else if(this.userPos === 'STORE'){
					ccp=utils.showstoreNameBystoreId()
					return ccp[id]
				}
				
				
			},
			
			openDialog(num){
				this.storeList=JSON.parse(localStorage.getItem('userInfo')).stores.map(p => {
					return {
						label:p.storeName,
						value:p.storeId
					}
				})
				this.whichMethods=num
				if(num == 0){
					this.text=this.$t('other.a1936')
					
				}else if(num == 1) {
					this.text=this.$t('other.a1937')
					
				}else if(num == 2){
					this.text=this.$t('other.a1938')
					if(this.targetList.length == 0){
						this.$message.error(this.$t('other.a1939'))
						return
					}
				}
				this.showStore=true
			},
			
			massGenerage(){
				let params={
					categoryIds:[],
					itemIds:[],
					shopIds:[],
					storeId:this.chosedStore.value,
					type:this.whichMethods,
					userId:this.userId,
					userName:this.userName,
					storeName:this.chosedStore.label
				}
				if(this.whichMethods===0){
					params.shopIds.push(this.chooseParams[0])
					
				}else if(this.whichMethods === 1){
					params.categoryIds=this.chooseParams.slice(1)
					params.shopIds=[this.chooseParams[0]]
				}else if(this.whichMethods === 2){
					params.itemIds=this.targetList.map(p => {return p.itemId})
					params.shopIds=null
				}
				console.log(params)
				this.batchCreateStoreItem(params)
				this.chosedStore=''
				this.showStore=false
				
				
			},
			
			handleChange(value) {
				console.log(value)
				if(value.length === 1){
					this.catergoryType=0
				}else{
					this.catergoryType=1
				}
				console.log(this.cateGoryListCopy)
				this.choseCategroyId=value[value.length-1];
				let categoryIds=[];
				this.cateGoryListCopy.forEach((p)=>{
				this.pushIds(p,categoryIds,false);
				})
				let arr=new Set([...categoryIds])
				let arr2=Array.from(arr)
				this.chooseParams=arr2
				console.log(arr2)
				arr2.unshift(value[0])
				
				const params={
					categoryIds:arr2.length == 1  ? null : arr2,
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					type:this.type,
					shopId: arr2[0],
					logisticsName:this.productStatua
				}
				
				this.getShopAllItems(params)
				
			  
			},
			getCategory(value) {
				let category={};
				this.cateGoryListCopy.forEach((p)=>{
					if(p.value==value){
						category= p;
					}
					if(p.hasChildren){
						p.children.forEach((q)=>{
							if(q.value==value){
								category= q;
							}
							if(q.hasChildren){
								q.children.forEach((r)=>{
									if(r.value==value){
										category= r;
									}
								})
							}
						})
					}
				})
				return category;
				},
				
				pushIds(category,ids,isVal){
					if(isVal){
						if(category.hasChildren){
							category.children.forEach((p)=>{
							this.pushIds(p,ids,true);
							})
						}else{
							ids.push(category.value)
						}
					}else{
						if(category.value==this.choseCategroyId){
							this.pushIds(category,ids,true);
						}else{
							if(category.hasChildren){
								category.children.forEach((p)=>{
								this.pushIds(p,ids,false);
								})
							}
						}
					}
				},
			getCategoryByshipId(){
				let allShopId=this.shopList.map(p => {return p.value}).slice(1)
				console.log(allShopId)
				allShopId.forEach(p => {
					this.getCategoryByshop({shopId:p})
				})
				
				
				
			},
			
			getList(item){
				console.log(item)
				console.log(this.targetList)
				// this.SET_ITEM_TRUE(item)
				
			},
			//查看商品的订单
			viewGoodsOrder(item,variation){
				console.log(item)
				console.log(variation)
				let params=null
				if(!item.hasVariation) {
					params={
						itemId:item.itemId,
						skuId:0
					}
				}else{
					params={
						itemId:variation.itemId,
						skuId:variation.variationId
					}
				}
				console.log(params)
				this.$router.push({path:'/orders/shopee',query:{...params}})
			},
			//查看商品的销售情况 
			viewSales(item,variation) {
				let params={}
				if(item.hasVariation) {
					params={
						end:utils.getRecentSevenDay(0),
						start:utils.getRecentSevenDay(-7),
						itemId:item.itemId,
						shopId:item.shopid,
						variationId:variation.variationId
					}
				}else{
					params={
						end:utils.getRecentSevenDay(0),
						start:utils.getRecentSevenDay(-7),
						itemId:item.itemId,
						shopId:item.shopid,
						variationId:0
					}
				}
				console.log(params)
				this.getItemSales(params)
				this.getInventoryTurnover(params)
				this.salesItem=params
				this.showSales=true
			},
			
			
			handleClick(num) {
			
			   if(num === 0) {
				   this.selectShop=''
				   this.isShopee=true
				   this.shopList=[{
				       	value: '',
				    	label: this.$t('other.a1915')
				       },
				   	]
					this.shipId= {
						value:{
							label:''
						}
					},
				   this.userShops.forEach(item => {
				   	let oop={
				   		label:item.shopName,
				   		value:item.shopId
				   	}
				   	this.shopList.push(oop)
				   })
				   this.getShopItems()
			   }else if(num === 1) {
				    
				   
				  this.shopList=[{
				  	value: '',
				   	label: this.$t('other.a1915')
				      },
				  	]
	
				   let arr=this.lazadashopId.map(p => {
					  return {
						   label:p.name,
						   value:p.sellerId
					   }
					 })
					 console.log(arr)
				  //  arr.forEach(p => {
					//    this.shopList.push(p)
				  //  })
				
			   }
			   this.getShopItems()
			  },
			ttp(){
				let lazadaShops=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
				if(lazadaShops){
					this.shopList=lazadaShops.map(p => {
						return {
							label:p.name,
							value:p.sellerId
						}
					})
				}
				this.shopList.unshift({
					value: null,
					label: this.$t('other.a1915')
				})
				this.getDataPrams.shopIds=lazadaShops.map(p => {return p.sellerId})
				this.getShopItems()
				
				
			},
			
			// getremind() {
			// 	this.stockRemindList = [];
			// 	this.remindCount = 0;
			// 	this.userShops.forEach((shop) => {
			// 		api.getShopStockRemind({
			// 			shop_id: shop.shopId
			// 		}).then(res => {
			// 			if (res.code === 200) {
						
			// 				res.data.forEach((stocks) => {
			// 					this.stockRemindList.push(stocks);
			// 					this.remindCount++;
			// 				})

			// 			}
			// 		})
			// 	});
			// },
			changeImgURL(item) {
				return item.image
			},
		
			addBindToList(item, variation) {
				if (variation == null) {
					variation = {
						variationId: 0
					}
				}
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "shopId", this.shipId);
				this.$set(param, "variation", variation);
				let isInList = false;
				for (let i = 0; i < this.bindItemList.length; i++) {
					if (this.bindItemList[i].itemId == param.itemId) {
						if (!this.bindItemList[i].hasVariation && !param.hasVariation) isInList = true;
						if (this.bindItemList[i].hasVariation && param.hasVariation &&
							this.bindItemList[i].variation.variationId == param.variation.variationId) isInList = true;
					}

				}
				if (!isInList) this.bindItemList.push(param);
				this.itemCount = this.bindItemList.length
				console.log('需要绑定的商品',this.bindItemList)
			},
		
			deleteChoose(item) {
				if(item.shopee) {
					this.$confirm(this.$t('other.a1940'), this.$t("other.a142"), {
					  confirmButtonText: this.$t('other.a145'),
					  cancelButtonText: this.$t('other.a146'),
					  type: 'warning'
					}).then(() => {
					  var index = this.isChooseList.findIndex(choose => {
					  	if (choose.itemId == item.itemId && choose.variation.variationId == item.variation.variationId) {
					  		return true
					  	}
					  })
					  
					  this.mygoodslist.forEach(p => {
					  	if(item.itemId==p.itemId){
					  		if(item.hasVariation&&p.hasVariation){
					  			p.variations.forEach(q=>{
					  				if(q.variationId==item.variation.variationId){
					  					q.checked=false;
					  				}
					  			})
					  		}else if(!item.hasVariation&&!p.hasVariation){
					  			p.checked =false
					  		}
					  	}
					  })
					  
					  this.isChooseList.splice(index, 1);
					  this.count = this.isChooseList.length;
					}).catch(() => {
						
					 
					});
					
					
					
				}else {
					let index = this.isChooseList.findIndex(choose => {
						if (choose.itemId == item.itemId && choose.variation.variationId == item.variation.variationId) {
							return true
						}
					})
					
					this.lazadaitems.forEach(p => {
						if(item.itemId==p.itemId){
							if(item.hasVariation&&p.hasVariation){
								p.variations.forEach(q=>{
									if(q.variationId==item.variation.variationId){
										q.checked=false;
									}
								})
							}else if(!item.hasVariation&&!p.hasVariation){
								p.checked =false
							}
						}
					})
					console.log(index)
					console.log(this.mygoodslist)
					this.isChooseList.splice(index, 1);
					this.count = this.isChooseList.length;
				}
				
			},
			getShopItemsCopy(){
				console.log(this.selectShop)
				this.getDataPrams.page=0
				if(this.selectShop == null){
					let lazadaShops=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
					this.getDataPrams.shopIds=lazadaShops.map(p => {return p.sellerId})
				}else{
					this.getDataPrams.shopIds=[this.selectShop]
				}

				this.getShopItems()
			},
			//获取lazada商品数据
			getShopItems() {
				this.getLazadaWarehouseitems(this.getDataPrams)
			},

			
			getShopItems01() {
				
				const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					type:this.type,
					shopId: this.selectShop,
					logisticsName:this.productStatua
				}
				
				this.getShopAllItems(params)
			},
			// updateFromShopee() {
			// 	if (this.selectShop == '') {
			// 		this.showMessage(this.$t('other.a1917'))
			// 	} else {
			// 		api.updateItems(this.selectShop).then(res => {
			// 			if (res.code === 200) {
			// 				this.showMessage(this.$t('other.a1918'))
			// 				this.getShopAllItems(this.selectShop)
			// 			}
			// 		})
			// 	}

			// },
			//创建采购单
			createOrder() {
				
				let variantList = [];
				let chooseList = this.isChooseList;
				console.log(chooseList)
				
				if (chooseList.length == 0) {
					this.showMessage(this.$t('other.a1919'));
					return;
				}
				if (this.chosedStore == '') {
					this.showMessage(this.$t('other.a1920'));
					return;
				}
				for (let i = 0; i < chooseList.length; i++) {
				
					let variation = {
						address:'',
						cost:chooseList[i].cost,
			            itemId:chooseList[i].itemId,
						itemName:chooseList[i].name,
						shopName:chooseList[i].shopName,
						component:chooseList[i].component,
						shopId:chooseList[i].shopid,
						image:chooseList[i].image,
						skuName:chooseList[i].variation.name,
						storeId:this.chosedStore.value,
						storeName:this.chosedStore.storeName,
						userId:this.userId,
						userName:this.userName,
						variationId:chooseList[i].variation.variationId,
						shopee:chooseList[i].shopee,
						packageHeight:chooseList[i].packageHeight,
						packageLength:chooseList[i].packageLength,
						packageWidth:chooseList[i].packageWidth,
						weight:chooseList[i].weight,
						rate:Number(chooseList[i].rate)
					}
					
					variantList.push(variation);
				}
				
				console.log(variantList)
				this.addGoodsInStore(variantList)
				this.storetable=true
		
			},
			showMessage(massage) {
				this.dialogVisible = true;
				this.visiableMessage = massage;
			},
			getTime(time) {
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp
			},
			//状态转换
			conversionStatus(ttp) {
				if(ttp){
					return this.$t('mygoods.yes')
				}else{
					return this.$t('mygoods.no')
				}
			},

			allInput(){
				this.variantList.forEach(p => {
					p.storeId=this.chosedStore.value
					p.storeName=this.chosedStore.storeName
				})
				
				console.log(this.variantList)
				this.addGoodsInStore(this.variantList)
				this.dialogVisibleThree=false
				this.storetable=true
				
			},

			inputProduct(){
				let params=JSON.parse(JSON.stringify(this.getDataPrams))
				params.offset=this.lazadaCount+1
				console.log(params)
				mygoods
				.getLazadaWarehouseitems(params)
				.then(res => {
					if(res.code === 200 ){
						console.log('lazada商店商品信息',res.data)
						this.storeList = [];
						let list=JSON.parse(localStorage.getItem('userInfo')).stores
						for (let i = 0; i < list.length; i++) {
							if(list[i].isUsed && list[i].storeType !== 4){
								this.storeList.push({
									value: list[i].storeId,
									label: list[i].storeName + '(' + list[i].userName + ')',
									storeName:list[i].storeName
								})
							}
						}
						
						let chooseList=[]
						res.data.items.forEach(p => {
							if(p.hasVariation){
								p.variations.forEach(i => {
									i.shopName=p.shopName
									i.shopId=p.shopid
									i.shopee=p.shopee
									i.attributeUrl=i.attributeUrl ? i.attributeUrl : p.image
									chooseList.push(i)
								})
							}else{
								chooseList.push({
									attributeUrl:p.image,
									cusCode:p.cusCode,
									itemId:p.itemId,
									name:p.name,
									price:p.price,
									shopName:p.shopName,
									shopId:p.shopid,
									shopee:p.shopee,
									rate:p.rate,
									reservedStock:p.reservedStock,
									status:p.status,
									stock:p.stock,
									variationId:p.variationId,
									variationSku:p.variationSku,
									
								})
							}
						})

						console.log('chooseList',chooseList)

						for (let i = 0; i < chooseList.length; i++) {
							let variation = {
								address:'',
								cost:0,
								itemId:chooseList[i].itemId,
								itemName:chooseList[i].name,
								shopName:chooseList[i].shopName,
								component:this.isComponent,
								shopId:chooseList[i].shopId,
								image:chooseList[i].attributeUrl,
								skuName:chooseList[i].variationSku,
								storeId:this.chosedStore.value,
								storeName:this.chosedStore.storeName,
								userId:this.userId,
								userName:this.userName,
								variationId:chooseList[i].variationId,
								shopee:chooseList[i].shopee,
								packageHeight:chooseList[i].packageHeight ? chooseList[i].packageHeight : null,
								packageLength:chooseList[i].packageLength ? chooseList[i].packageLength : null,
								packageWidth:chooseList[i].packageWidth ? chooseList[i].packageWidth : null,
								weight:chooseList[i].weight ? chooseList[i].weight : null,
								rate:Number(chooseList[i].rate)
							}
							this.variantList.push(variation);
						}

						this.dialogVisibleThree=true
					
						
					}
				})
			},
		
			tobuShopee(){
				this.$message.success(this.$t('other.a1941'))
				let shop=this.selectShop
				if(!shop) {
					let arr = this.shopList.map(p => {
						if(p.value !== ''){
							return p.value
						}
						
					})
					let  arr2=arr.splice(1)
					arr2.forEach(p => {
						this.tongBuLazada({shopId:p,userId:this.userId})
					})
					
				}else{
					this.tongBuLazada({shopId:this.selectShop,userId:this.userId})
				}
				
				
				
			},
			tocaiguo() {
		
				this.storeList = [];
				let list=JSON.parse(localStorage.getItem('userInfo')).stores

				for (let i = 0; i < list.length; i++) {
					if(list[i].isUsed && list[i].storeType !== 4){

						this.storeList.push({
							value: list[i].storeId,
							label: list[i].storeName + '(' + list[i].userName + ')',
							storeName:list[i].storeName
						})
					}
				}
				this.caigouTable = true;
			},
		
		
			targetVariation(item, variation,componets,num,indexOne,index) {
				console.log(variation)
				this.catergoryType=2
				let ttp = item.checked
			    item.checked = !ttp
				
				variation==null?null:variation.checked=!variation.checked
		
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "num", 0);
				this.$set(param,"skuName" ,'')
				this.$set(param,"cost" ,0)
				this.$set(param,"component" ,componets)
		
				// this.$set(param,"shopName" ,this.shipId.value.label)
				this.$set(param, "anotherName", "");
				this.$set(param, "variation", variation == null ? {
					variationId: 0,
					name: '',
					stock: 0
				} : variation)
				let isInList = false;
				for (let i = 0; i < this.isChooseList.length; i++) {
					if ((param.hasVariation && this.isChooseList[i].hasVariation &&
							this.isChooseList[i].variation.variationId == param.variation.variationId) ||
						(!param.hasVariation && !this.isChooseList[i].hasVariation && this.isChooseList[i].itemId == param.itemId))
						{
							isInList = true;
							this.isChooseList.splice(i,1)
							
						}
				}
				if (!isInList) this.isChooseList.push(param);
				this.count = this.isChooseList.length
				this.KEEP_CHOOSED_ITEM(this.isChooseList)
				console.log('选中要加入仓库的商品',this.isChooseList)
			},
			cleanForm() {
				this.isChooseList = [];
				this.KEEP_CHOOSED_ITEM(this.isChooseList)
				this.sellerMessage = '';
				this.count=this.isChooseList.length
				
				if(this.isShopee){
					this.getShopItems01()
				}else{
					this.getShopItems()
				}
			},
			
			
			//控制每页显示订单条数
			handleSizeChange(val) {
							 console.log(`每页 ${val} 条`);
							 this.getDataPrams.offset=parseInt(`${val}`)
							 this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
						this.getDataPrams.page=(parseInt(`${val}`) -1) * this.getDataPrams.offset
						 this.getShopItems(this.getDataPrams)
						
			  },
			  //搜索商品名称查找
			  goTosearch(){
				this.getDataPrams.itemName=this.itemNameQuery
				   this.getLazadaWarehouseitems(this.getDataPrams)
			  },
		
			
			   closeWindow(){
				   this.storetable=false
				   this.caigouTable=false
				   this.count=0
				   this.bindreport=false
				   this.bindTable=false
				   this.isChooseList=[]
				   this.SET_SUCCESS_ERROR_NULL()
				   this.ttp()
			   },
			  ttp01(num){
			  	
			  	if(this.active == num) {
			  		this.active=-1
			  	}else{
			  		this.active=num
			  	}
			  },


		}
	}
</script>

<style>

	.mygoods .demo-table-expand {
		font-size: 0;
	}

	.mygoods .demo-table-expand label {
		width: 120px;
		color: #99a9bf;
	}

	.mygoods .demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	/* .mygoods {
		flex: 1;
		padding: 60px 0 0 221px;
		
	} */

	.mygoods .el-dialog__body {
		padding-top: 0px;
	}

	.mygoods .list-item {
		justify-content: space-around;
		align-items: center;
		margin: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}

/* 	.list-variation {
		justify-content: space-around;
		align-items: center;
	} */

	.mygoods .item-view {
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding: 10px 20px;
		border-radius: 10px;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); */
	}
	.mygoods .goods-title-desc .el-row {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    box-sizing: border-box;
	    padding: 0 20px;
	}


	.mygoods .variation-list {
		padding: 5px 0;
		border-bottom: 1px solid #eee;
	}

	.mygoods .el-collapse-item__content {
		padding: 0rem;
	}

	.mygoods  .goods-pic {
		width: 80px;
		height: 80px;
		margin-right: 25px;
	}

	.mygoods .el-dialog__body {
		padding-bottom: 0px !important;
	}

	img {
		width: 100%;
	}

	.mygoods .el-collapse-item__header {

		float: right;
	}

	.mygoods .goods-desc {
		display: flex;
		margin-left: 10px;
	
	}

	.mygoods .goods-item {
		display: inline-block;
		margin: 2px 10px;
		color: #00193A;
	}
	.mygoods .goods-btn {
		display: inline-block;
		text-align: right;
	}
	.mygoods .goods-title-desc{
		display: flex;
		flex-direction: column;
	}
	

	.mygoods .goods-title {
		width: 300px;
		
		    box-sizing: border-box;
		    padding: 5px;
	}

	.mygoods .mygoods-title,
	.query-list {
		display: flex;
		justify-content: space-between;
		margin: 15px 0 0 0;
		padding: 10px 0;
		/* border-bottom: 1px #E0E0E0 solid; */
		
	}

	.mygoods .shop-choose {
		display: inline-block;
		margin-right: 15px;
	}

	.mygoods .create {
		position: relative;
		margin-left: 30px;
	}

	.mygoods .cirlle {
		position: absolute;
		top: -15px;
		left: -13px;
		display: block;
		width: 30px;
		height: 30px;
		background-color: red;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
		color: #fff;
	}
	.mygoods .mygoods-search {
		display: flex;
	}
	.mygoods .quit-box{
		display: flex;
		justify-content: center;
		width: 90%;
	}
	.mygoods .Pager{
		position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
	.mygoods .choos-store{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 5px 10px;
	}
	.mygoods .quit-wapper{
		display: flex;
		justify-content: space-between;
		width: 55%;
	}
	.mygoods .quit-wrapper-item{
		font-size: 18px;
	}
	.mygoods .ttp-uu{
		text-align: right;
		box-sizing: border-box;
		padding: 10px;
		width: 100%;
	}
	.serchCuscode{
		display: flex;
		margin-left: 15px;
		
	}
	
	/** 去除input输入框样式 */
	input[type=number]::-webkit-inner-spin-button {
	  -webkit-appearance: none;
	}
	.mygoods .number__input {
	  border: 1px solid #ccc;
	}
	.mygoods .el-dialog--center .el-dialog__body{
		padding: 0px !important;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
	}

	.mygoods .el-message--success{
		z-index: 9999999!important;
	}
/* 	.mygoods .el-table__header-wrapper{
		display: flex;
		justify-content: center;
	} */
	.mygoods .el-table__empty-text{
		text-align: center;
	}
/* 	.mygoods .el-table__body-wrapper{
		display: flex;
		justify-content: center;
	} */
	.mygoods .header-top{
	
		position: fixed;
		z-index: 7;
	    top:138px;
		background-color: #fff;
		left: 205px;
		right: 0;

		box-sizing: border-box;
		padding: 0 5px;
		border-bottom: 1px solid #eee;
		
	}
	.mygoods .mygoods-list{
	
		margin-bottom: 50px;
	
	}
	.mygoods  .query-list-tcp{
		display: flex;
	}
	.mygoods  .el-tabs__header{
		position: fixed;
		margin: 10px 0  0 30px;
		z-index: 7;
	}
/* 	lazada板面 */
     .mygoods-list-lazada{
		 margin-top: 20px;
	 }
	 
	 .mygoods .item-view-lazada{
		 display: flex;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	 }
	 
	 .mygoods .unfold:nth-of-type(n+1){
	 	display: none;
	 	
	 }
	 
	 .mygoods .list-item{
		 border-radius: 10px;
	 }

</style>
